import React, { useState } from 'react'
import { Dropdown, Menu } from 'antd'
import { Link, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { AiOutlineDown } from 'react-icons/ai'

import { server, stringifyDate, usePet } from '../../modules'

import Receive from '../reusable/receive'
import Confirm from './confirm'

const Requests = ({ loading, investigations, dep, trailing = 'queue', error, string, page, limit, Paginate, entries, onComplete = () => null }) => {
    const [cId, setCId] = useState()
    
    const { id } = useParams()
    const { user } = useSelector(state => state.application)

    let callback = (_, notify, ops) => {
        onComplete()
        notify('Changes have been saved', ops('success'))
    }

    const [, toggleSeen] = usePet('toggleSeenStatus', { 
        id: cId
    }, { notify: true, callback, manual: true, load: { msg: 'Changing status...' } }) 

    const [, toggleDiscard] = usePet('toggleDiscardStatus', { 
        id: cId
    }, { notify: true, callback, manual: true, load: { msg: 'Changing status...' } })

    return (
        <Receive
            progress
            loading={loading}
            error={error}>
            {
                entries?.length > 0 ?
                    <>
                        <div className="overflow-x-auto">
                            <table className="table-auto w-full">
                                {/* Table header */}
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">No</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Item</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Paid On</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center"></div>
                                        </th>
                                    </tr>
                                </thead>
                                {/* Table body */}
                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        entries.map((entry, key) =>
                                            <tr>
                                                <td className="p-2">
                                                    <div className="text-center">
                                                        { ((page - 1) * limit) + (key + 1) }.
                                                    </div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-left">{ entry.item?.name ?? entry.ref.name }</div>
                                                    <div className="flex space-x-2 pl-1 items-center">
                                                        <div className={ `w-2 h-2 rounded-full bg-${ entry.filled ? 'green' : entry.discarded ? 'gray' : 'yellow'}-500 shadow` }></div>
                                                        <p className={ `text-${ entry.filled ? 'green': entry.discarded ? 'gray' : 'yellow'}-500 block text-xs italic mb-0` }>{ entry.filled ? `Seen by ${entry?.filledBy?.name}`: entry.discarded ? 'Discarded' : 'Pending' }</p>
                                                    </div>
                                                    { entry.filled && <p className="text-gray-500 text-xs block italic my-0">Seen on { stringifyDate(entry?.filledOn) }</p> }
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{stringifyDate(entry.date)}</div>
                                                </td>
                                                <td className="p-2 text-center">
                                                    <Dropdown
                                                        overlay={
                                                            <Menu>
                                                                <Link to={ `/app/${dep}/${trailing}/${id}/${entry._id}` }><Menu.Item>{ entry.filled ? 'Review' : investigations ? 'Enter' : 'Write' } { investigations ? 'Results' : 'Commentary' }</Menu.Item></Link>
                                                                { 
                                                                    dep === 'lab' && entry?.filled && 
                                                                    <a target="_blank" href={ `${server}/entry/${entry._id}/print`} >
                                                                        <Menu.Item onClick={ () => null }>Print Results</Menu.Item>
                                                                    </a>
                                                                }
                                                                {
                                                                    !entry?.filled &&
                                                                    <Menu.Item onClick={ () => {
                                                                        setCId(entry?._id)
                                                                        Confirm({
                                                                            title: entry?.discarded ? 'Restore This Request' : 'Discard This Request',
                                                                            message: entry?.discarded ? 'This will undo the discard action applied to this request' : 'This will discard this item from the pending queue',
                                                                            okText: entry?.discarded ? 'Restore Request' : 'Discard Request',
                                                                            onOk: toggleDiscard
                                                                        }) 
                                                                    } }>{ entry?.discarded ? 'Restore Request' : 'Discard Request' }</Menu.Item>
                                                                }
                                                                { 
                                                                    (user?.issuperuser || !entry?.filled) &&
                                                                    <Menu.Item onClick={ () => {
                                                                        setCId(entry?._id)
                                                                        Confirm({
                                                                            title: entry?.filled ? 'Mark as Incomplete' : 'Mark as Completed',
                                                                            message: `This will mark this request as ${entry?.filled ? 'incomplete' : 'complete' }`,
                                                                            okText: entry?.filled ? 'Mark Incomplete' : 'Mark Completed',
                                                                            onOk: toggleSeen
                                                                        })
                                                                    } }>{ entry?.filled ? 'Mark Incomplete' : 'Mark Completed' }</Menu.Item>
                                                                }
                                                            </Menu>
                                                        }>
                                                        <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                        {Paginate}
                    </>
                :
                    <div className="w-full h-16 flex items-center justify-center">
                        <p className="font-semibold text-base">No requests { string?.trim().length > 2 ? `matching "${string}"` : "" } were found</p>
                    </div>
            }
        </Receive>
    )
}

export default Requests